import { isNotBlank, isNotNullNorUndefined, objectValues } from "@/utils/ts-utils"

export const SynchroStatus = {
  RUNNING: "running",
  COMPLETE: "complete",
  CANCELED: "canceled",
  ERROR: "error",
} as const
export type SynchroStatus = (typeof SynchroStatus)[keyof typeof SynchroStatus]

export const SynchroSources = {
  V2: "synchro:mbv2",
  V4: "mbv4",
  V0: "synchro:barnesdatas",
  Apimo: "synchro:apimo",
} as const
export type SynchroSources = (typeof SynchroSources)[keyof typeof SynchroSources]
export const SynchroSourcesMyBarnes = [SynchroSources.V2, SynchroSources.V4, SynchroSources.V0]
export const SynchroSourcesPGB = [SynchroSources.Apimo]
export const SynchroSourcesValues = objectValues(SynchroSources)
export type SynchroSourcesValue = (typeof SynchroSourcesValues)[number]
export type SynchroSourcesMyBarnes = (typeof SynchroSourcesMyBarnes)[number]
export type SynchroSourcesPGB = (typeof SynchroSourcesPGB)[number]

export const is_source_mybarnes = <
  T extends { internalSource?: SynchroSourcesValue | string | null | undefined },
>(
  entity: T | undefined | null
) => {
  return (
    isNotNullNorUndefined(entity) &&
    isNotBlank(entity.internalSource) &&
    (SynchroSourcesMyBarnes.includes(entity.internalSource as SynchroSourcesMyBarnes) ||
      SynchroSourcesMyBarnes.includes(`synchro:${entity.internalSource}` as SynchroSourcesMyBarnes))
  )
}
